module.exports = __webpack_public_path__ + "static/media/swedbank.f6e53adb.png";